/* globals VXConfig */
import React                    from 'react';
import PropTypes                from 'prop-types';
import Grid2                    from "../Grid2/Grid2";
import ActorTile                from "../Grid2/Tiles/ActorTile";
import withActors               from '../HigherOrderComponents/Actors/withActors';
import Flux                     from '../../flux/Flux';
import {VXButtonLineConfig}     from '../SimpleElements/VXButton/VXButtonConfig';
import {getCommonTranslation}   from '../../utils/TranslationHelper';
import VXButtonOutline          from '../SimpleElements/VXButton/Presets/VXButtonOutline';
import LogoLoader               from '../Loader/LogoLoader';
import FilterNoResult             from '../Filter/FilterNoResult';
import {generateModelsV3Filter} from './CamsHelper';
import {openOnboardingModal}    from '../ModalBox/ModalBoxFactory.js';
import Translations from '../../utils/Translations.js';

const Grid    = withActors(Grid2);
const TILES_PER_PAGE = 27;
let canLoadMore = true;

class CamsGrid extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
			loading: true,
			showLoadMoreButton: false,
			offset: 0,
			showSmallLoader: false,
		};

		this.autoLoads = 2;
		this.gridRef   = null;

        this.onActorDataLoadChange = this.onActorDataLoadChange.bind(this);
        this.onActorDataChange     = this.onActorDataChange.bind(this);
        this.onScroll              = this.onScroll.bind(this);
        this.loadMore              = this.loadMore.bind(this);
    }


    componentDidMount() {
		Flux.Actors.addActorsDataLoadListener(this.onActorDataLoadChange);
		Flux.Actors.addActorsDataChangeListener(this.onActorDataChange);
		Flux.Browser.addWindowScrollListener(this.onScroll);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.filter !== this.props.filter || prevProps.order !== this.props.order) {
			this.setState({offset: 0, loading: true, showLoadMoreButton: false, showSmallLoader: false});
			canLoadMore    = true;
			this.autoLoads = 2;
		}
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowScrollListener(this.onScroll);
		Flux.Actors.removeActorsDataChangeListener(this.onActorDataChange);
		Flux.Actors.removeActorsDataLoadListener(this.onActorDataLoadChange);
	}

	onActorDataChange(id) {
		if (id !== this.props.gridId) {
			return;
		}
		this.setState({showSmallLoader: false});
	}

	onActorDataLoadChange() {
		const loading = Flux.Actors.isActorsDataLoading(generateModelsV3Filter(this.props.filter), this.props.order);
		canLoadMore   = true;
		this.setState({loading});
	}

	loadMore() {
		this.setState({offset: this.state.offset + TILES_PER_PAGE, loading: true, showSmallLoader: true});
	}

	onScroll() {
		if (window.innerHeight - this.gridRef.getBoundingClientRect().bottom > 100 && canLoadMore && this.props.total > TILES_PER_PAGE) {
			if (this.autoLoads > 0) {
				this.loadMore();
				this.autoLoads -= 1;
			} else {
				this.setState({showLoadMoreButton: true});
			}
			canLoadMore = false;
		}
	}

    getTileSizes() {
        if (this.props.isMobile) {
            return [{index: 0, size: 2}];
        } else if (this.props.showFilter) {
			return [{index: 0, size: 1}];
		} else if (Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md) {
			return [{index: 0, size: 1}];
		}
		return [{index: 0, size: 2}];
	}

    render() {
        const columns   = {xs: 2, sm: this.props.showFilter ? 2 : 3, md: this.props.showFilter ? 3 : 4, lg: this.props.showFilter ? 3 : 4};
        const tileSizes = this.getTileSizes();
		const onlyFullRows = (TILES_PER_PAGE + this.state.offset) < this.props.total;
        return <div className={'cams__grid' + (this.props.showFilter ? " cams__grid--show" : '')} ref={ref => this.gridRef = ref}>
					<div >
						<Grid
							//Grid2
							defaultTileClass={ActorTile}
							columns={columns}
							tilePadding={Flux.Constants.Grid2.TilePadding.SMALL}
							headlineType={'div'}
							defaultTileConfig={{}}
							tileSizes={tileSizes}
							onlyFullRows={onlyFullRows}
							//Loader
							useFullscreenLoader={true}
							loading={this.state.loading}
							//withActors
							first={TILES_PER_PAGE}
							filter={generateModelsV3Filter(this.props.filter)}
							order={this.props.order}
							offset={this.state.offset}
							id={this.props.gridId}
							isLoadMore={this.state.offset >= TILES_PER_PAGE}
							useCache={false}
							total={this.props.total}
							isMobile={this.props.isMobile}
							isV3={true}
							onlineFilter={generateModelsV3Filter(this.props.filter, true)}
						/>
					</div>
					{(this.state.showSmallLoader || this.state.loading) && <div className="h-pos-relative h-height-full"><LogoLoader className={this.props.total === 0 ? '-center' : "-static"} pulse={true} /></div>}
					{(this.props.total < TILES_PER_PAGE) && !this.state.loading && <FilterNoResult resetFilter={this.props.resetFilter} fullHeight={this.props.total === 0} headlineText={Translations.get('ProSearchDiscoverSimilarGirls')} sublineText={Translations.get('ProSearchDiscoverSimilarGirlsMobile')}/>}
					{!this.state.showSmallLoader && this.state.showLoadMoreButton && this.props.total > TILES_PER_PAGE && onlyFullRows && !this.state.loading &&
					<div className="content-box--cta">
							<VXButtonOutline line1={[new VXButtonLineConfig(getCommonTranslation('load-more'))]} onClick={this.loadMore} />
					</div>}
        </div>;
    }

}

CamsGrid.propTypes = {
    showFilter:  PropTypes.bool,
    isMobile:    PropTypes.bool,
    isTablet:    PropTypes.bool,
	resetFilter: PropTypes.func,
	filter:      PropTypes.array,
	order:       PropTypes.string,
	total:       PropTypes.number,
	gridId:      PropTypes.string,
};

export default CamsGrid;
